"use strict";
/**
 * @module Services.GatewayControl
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_gateway_client_request_1 = require("./../../../services/gateway-control/base-gateway-client-request");
var gateway_request_type_1 = require("./../../../services/gateway-control/gateway-request-type");
/**
 * Data type for a GATEWAY_CLIENT_REQUEST get operation detail request.
 */
var GatewayClientGetOperationDetailRequest = /** @class */ (function (_super) {
    __extends(GatewayClientGetOperationDetailRequest, _super);
    /**
     * Create a new GatewayClientGetOperationDetailRequest instance
     *
     * @param sessionId  the gateway client session id
     * @param operationName  the name of the operation to get details for
     */
    function GatewayClientGetOperationDetailRequest(sessionId, operationName) {
        var _this = _super.call(this, sessionId) || this;
        _this.type = gateway_request_type_1.GatewayRequestType.GET_OPERATION_DETAIL;
        _this.operationName = operationName;
        return _this;
    }
    return GatewayClientGetOperationDetailRequest;
}(base_gateway_client_request_1.BaseGatewayClientRequest));
exports.GatewayClientGetOperationDetailRequest = GatewayClientGetOperationDetailRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/gateway-control/operations/gateway-client-get-operation-detail-request.js
// module id = 1951
// module chunks = 1